const strings = {
  labels: {
    toasts: {
      callMissedDidTitle: (missedCount: number) =>
        missedCount === 1
          ? 'You missed 1 direct call'
          : `You missed ${missedCount} direct calls`,
      callMissedExternalTitle:
        'You missed a call due to the caller hanging up.',
      missedCallForQueue: (missedCount: number, queueName: string) =>
        `You have missed ${missedCount} call${missedCount > 1 ? 's' : ''} from the ${queueName} queue.`,
      errorConnection:
        'We encountered an issue while connecting your call. It has been sent to the next agent in the queue.',
      rolloverTimeout: `The call was missed because it reached the queue's rollover time limit.\n\nThis happens when a caller is on hold longer than the maximum time set for that queue.`,
    },
  },
} as const;

export default strings;
